module.exports = "pegasus/assets/tech/holiday/100.png";